<template>
    <app-layout>
        <hr class="w-12 main-bg h-1 mb-4 mx-auto mt-16">

        <h1 class="blue-text text-5xl font-bold text-center mb-12 px-4">More Locations</h1>

        <div class="grid grid-cols-1 md:grid-cols-2 container mx-auto gap-6">
            <div class="w-full mx-auto text-center bg-white rounded-xl p-8 shadow-sm" v-for="loc in moreLocs">
                <h3 class="text-xl xl:text-3xl font-bold mb-6">{{ loc.title }}</h3>

                <img 
                    v-if="loc.image" 
                    class="w-full max-w-xl rounded-xl mb-6" 
                    :src="require(`@/assets/png/more-locs/${loc.image}`)" 
                    alt=""
                >
                <iframe
                    class="w-full max-w-xl rounded-xl h-80 mb-6"
                    v-if="loc.map" 
                    :src="loc.map" 
                    style="border:0;" 
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
                <p v-for="locNote in loc.notes" class="font-semibold text-md xl:text-2xl max-w-sm md:max-w-xl">{{ locNote }}</p>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";
export default {
    name: "MoreLocations",
    components: {AppLayout},
    data() {
        return {
            moreLocs: [
                {
                    id: 1,
                    title: this.$t("more_locs.locs.loc1.title"),
                    notes: [
                        this.$t("more_locs.locs.loc1.working_hours"),
                        this.$t("more_locs.locs.loc1.phone"),
                        this.$t("more_locs.locs.loc1.address")
                    ],
                    image: 'torrance-office.jpg'
                },
                {
                    id: 2,
                    title: this.$t("more_locs.locs.loc2.title"),
                    notes: [
                        this.$t("more_locs.locs.loc2.working_hours"),
                        this.$t("more_locs.locs.loc2.phone"),
                        this.$t("more_locs.locs.loc2.address")
                    ],
                    alert: this.$t("more_locs.locs.loc2.alert"),
                    image: 'elephant-loc.jpeg'
                },
                {
                    id: 3,
                    title: this.$t("more_locs.locs.loc3.title"),
                    notes: [
                        this.$t("more_locs.locs.loc3.working_hours"),
                        this.$t("more_locs.locs.loc3.phone"),
                        this.$t("more_locs.locs.loc3.address")
                    ],
                    image: 'gul-tor-loc.jpeg'
                },
                // {
                //     id: 4,
                //     title: this.$t("more_locs.locs.loc4.title"),
                //     notes: [
                //         this.$t("more_locs.locs.loc4.working_hours"),
                //         this.$t("more_locs.locs.loc4.phone"),
                //         this.$t("more_locs.locs.loc4.address")
                //     ],
                //     image: 'gul-irvine-loc.jpeg'
                // },
                // {
                //     id: 5,
                //     title: this.$t("more_locs.locs.loc5.title"),
                //     notes: [
                //         this.$t("more_locs.locs.loc5.working_hours"),
                //         this.$t("more_locs.locs.loc5.address")
                //     ],
                //     image: 'tokyo-loc.jpeg'
                // },
                // {
                //     id: 6,
                //     title: this.$t("more_locs.locs.loc6.title"),
                //     notes: [
                //         this.$t("more_locs.locs.loc6.working_hours"),
                //         this.$t("more_locs.locs.loc6.sunday"),
                //         this.$t("more_locs.locs.loc6.address")
                //     ],
                //     image: 'daido-loc.jpeg'
                // },
                {
                    id: 7,
                    title: this.$t("more_locs.locs.loc7.title"),
                    notes: [
                        this.$t("more_locs.locs.loc7.working_hours"),
                        this.$t("more_locs.locs.loc7.sunday"),
                        this.$t("more_locs.locs.loc7.address")
                    ],
                    map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2698.441129031359!2d-122.30030629999999!3d47.44233990000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54905d47abf96451%3A0x7421a8b31cfb275f!2sICE%20International%20Currency%20Exchange!5e0!3m2!1sru!2skg!4v1760543602323!5m2!1sru!2skg'
                },
                {
                    id: 8,
                    title: this.$t("more_locs.locs.loc8.title"),
                    notes: [
                        this.$t("more_locs.locs.loc8.working_hours"),
                        this.$t("more_locs.locs.loc8.sunday"),
                        this.$t("more_locs.locs.loc8.address")
                    ],
                    map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2943.1977178718807!2d-83.4560738!3d42.4660834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8824aefed3de8e47%3A0xeebae8fd768a36a5!2sKoby%20Learning%20Group!5e0!3m2!1sru!2skg!4v1760538102307!5m2!1sru!2skg'
                },
            ]
        }
    }
}
</script>

<style scoped>

</style>